import { GetterTree } from 'vuex'
import LocationModel from '../models/Location'
import { LocationState } from './types'
import { RootState } from '@/Common/store/types'

export const getters: GetterTree<LocationState, RootState> = {
  currentLocation(state): any {
    return state.currentLocation
  },
  previousLocation(state): any {
    return state.previousLocation
  },
  locations(state): LocationModel[] | null {
    return state.locations
  },
  editLocation(state): any {
    return state.editLocation
  },
  defaultLocation(state): any {
    return state.defaultLocation
  },
}
